import { useAuth } from '@on3/ui-lib/index';
import { ArticleOffers } from '@public/components/Headlines/Article/Offers';
import { PageWrapper } from '@public/components/Layouts/PageWrapper';

import { ArticleBarrier } from './ArticleBarrier/ArticleBarrier';
import { ArticleWrapper, type IArticleWrapperProps } from './ArticleWrapper';
import { NascarBar } from './NascarBar/NascarBar';

const NASCAR_CATEGORY_KEY = 540543;

export const ArticleShell = (props: IArticleWrapperProps) => {
  const { user } = useAuth();
  const isSubscribed = !!user?.has;
  const isPremium = props.article?.isPremium;
  const showNascar =
    props?.article?.primaryCategory?.key === NASCAR_CATEGORY_KEY;

  return (
    <PageWrapper {...props} hideAds={!isSubscribed && isPremium}>
      {showNascar ? <NascarBar /> : null}
      <ArticleWrapper {...props} key={props?.article?.key} />
      {!isSubscribed && <ArticleBarrier />}
      <ArticleOffers />
    </PageWrapper>
  );
};
